import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { deriveWorkspacePersona, getPersonaRestrictedRedirect } from "@/config/workspacePersona";

/** Redirects educator personas away from leader-only URLs (matches sidebar exclusions). */
export const PersonaNavGuard = () => {
  const { userData } = useAuth();
  const location = useLocation();
  const persona = deriveWorkspacePersona(userData);
  const to = getPersonaRestrictedRedirect(persona, location.pathname);
  if (to) return <Navigate to={to} replace />;
  return <Outlet />;
};
